const requestMailErrorSelector = state => state.resetPassword.requestMailError && state.resetPassword.requestMailError.reduce(
  (acc, err) => ({ ...acc, [err.source.pointer.split('/').slice(-1)]: err.detail }),
  {}
);

export const changePasswordErrorSelector = state => state.resetPassword.changePasswordError && state.resetPassword.changePasswordError.reduce(
  (acc, err) => ({ ...acc, [err.source.pointer.split('/').slice(-1)]: err.detail }),
  {}
);

export default requestMailErrorSelector;
